import React from "react";

function NotFound() {
  document.title = `Not Found`;
  return <div>Not Found</div>;
}

export default NotFound;
